import us from '../../../defines';

export default function ColorPickerControl (selector, options) {
  let $colorCells;
  let selectedIdx;
  let settings;

  const init = (selector, options) => {
    let defaults = {
      defaultColorIdx: 0, // default color index
      columns: 13, // number of color cells per row (0 means 1 row)
      divClass: us.clsCLRPICKGRID, // the div to place the color picker grid in
      colorPalette: us.colorPalette, // color selections
      click: function ($colorCells) {
      }
    };
    settings = $.extend({}, defaults, options);

    // in the immediate scope of the plugin function, the this keyword refers to the jQuery object the plugin was invoked on.
    let $this = $(selector); // the associated parent html element
    selectedIdx = settings.defaultColorIdx;
    settings.columns = (settings.columns > 0) ? settings.columns : settings.color.length;

    let sCells = ''; // create abd add the color grid to the parent with the specified class
    for (var i = 0; i < settings.colorPalette.length; i++) { sCells += '<div style="background-color:' + settings.colorPalette[i] + ';"></div>'; }
    $this.html('<div class="' + settings.divClass + '">' + sCells + '</div>');

    $colorCells = $this.children('.' + settings.divClass).children('div'); // select the grid's color cells

    let w = ($colorCells.width() + 4) * settings.columns; // set width of cell grid =  space between cells x N cells/row
    $('.' + settings.divClass).css('width', w);

    $colorCells.each(function (i) { // add click event to each cell
      $(this).click(function () {
        setCheckState(i); // check the appropriate div
        settings.click(settings.colorPalette[i]); // issue user click
      });
    });
    setCheckState(settings.defaultColorIdx); // check the appropriate div
    selectedIdx = settings.defaultColorIdx; // save the selected color idx
  };

  const setCheckState = (i) => {
    let $cell;
    if (selectedIdx == i) return; // nothing to do
    if (i == -1 || i > settings.colorPalette.length - 1) i = 0; // keep index in-bounds

    if (selectedIdx > -1) { // clean up check state in previous color cell
      $cell = $colorCells.eq(selectedIdx);
      if ($cell.hasClass('check')) $cell.removeClass('check').removeClass('checkwht').removeClass('checkblk');
    }

    selectedIdx = i; // save the selected color idx
    $cell = $colorCells.eq(selectedIdx); // set checkmark in selected color
    let whiteFont = setWhiteFont(settings.colorPalette[i]);
    $cell.addClass('check').addClass(whiteFont ? 'checkwht' : 'checkblk');
  };

  const setWhiteFont = (hexColor) => {
    // compute brightness of color by converting to the Y component of YUV, which is brightness or luminance
    let decRGB = parseInt(hexColor.substr(1), 16); // integer RGB value
    let blue = (decRGB & 0xFF);
    let green = (decRGB >> 8) & 0xFF;
    let red = (decRGB >> 16) & 0xFF;
    //    don't need U and V, but fyi, they are:      U = 0.436 * (blue - Y) / (1 / 0.114);  V = 0.615 * (red - Y) / (1 / 0.299);
    let Y = parseInt((red * 0.299) + (green * 0.587) + (blue * 0.114), 10);
    return (Y <= 139);
  };

  this.selectByColor = (hexColor) => { // set the color selection to the passed hex color, e.g. "#ffff56"
    for (var i = 0; i < settings.colorPalette.length; i++) {
      if (settings.colorPalette[i] == hexColor) {
        setCheckState(i);
        break;
      }
    }
  };

  init(selector, options);
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/color-picker/color-picker-control.js